import useAddNewGroupListener from "./useAddNewGroupListener";
import useGroupRemovedListener from "./useGroupRemovedListener";
import useGroupRenameListener from "./useGroupRenameListener";

/**
 * @param {Object} root - The root node of the tree
 * @param {Object} groupTypes - Group types configuration
 * @param {Function} refreshTree - Callback to trigger re-render after mutations
 */
const useGroupTreeEventListeners = (root, groupTypes, refreshTree) => {
  useAddNewGroupListener(root, groupTypes, refreshTree);
  useGroupRemovedListener(root, refreshTree);
  useGroupRenameListener(root, refreshTree);
};

export default useGroupTreeEventListeners;
